export default __webpack_public_path__ + "static/logo-main-white-965d7600e21fc32db06a577b1e0d6e4c.png";